<template>
  <component :is="layout" />

  <Teleport to="#toast">
    <ToastComponent />
  </Teleport>
</template>

<script setup>
import { ref } from 'vue';
import { useRouter } from 'vue-router';
import ToastComponent from './components/ToastComponent.vue';

// Composables
const router = useRouter();

// Reactive properties
const layout = ref('DefaultLayout');

// Set layout on each request
router.beforeEach((to) => {
  if (to.meta.layout) {
    layout.value = to.meta.layout;
  } else {
    layout.value = 'DefaultLayout';
  }
});
</script>
